// ** Custom Components
import Text from "components/typography/Text";

//##################################

const formatPad = (string) => {
	return `0${string}`.slice(-2);
};

const formatTime = (seconds) => {
	const date = new Date(seconds * 1000);
	const hh = date.getUTCHours();
	const mm = date.getUTCMinutes();
	const ss = formatPad(date.getUTCSeconds());
	if (hh) {
		return `${hh}:${formatPad(mm)}:${ss}`;
	}
	return `${mm}:${ss}`;
};

//##################################

const Duration = ({ className, seconds, ...props }) => {
	return (
		<Text color="whiteAlways" {...props}>
			<time dateTime={`P${Math.round(seconds)}S`} className={className}>
				{formatTime(seconds)}
			</time>
		</Text>
	);
};

export default Duration;
